var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "reconciliation-step-template",
    {
      attrs: { nextStep: false, previousStep: false, loading: _vm.loading },
      on: {
        previous: function($event) {
          return _vm.$emit("previous")
        }
      }
    },
    [
      _c("template", { slot: "header" }, [_vm._v("   ")]),
      _vm._v(" "),
      _c("template", { slot: "content" }, [
        _c(
          "div",
          { staticClass: "wp-6 m-auto acenter" },
          [
            _c("i", {
              staticClass: "icon-email-statut-valid success-50 fs-131"
            }),
            _vm._v(" "),
            _c("p", { staticClass: "fs-4 semibold mt-6" }, [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm.$l10n.__(
                      "Votre fichier a été correctement configuré, il sera disponible dans quelques instants sur votre outil de rapprochement bancaire."
                    )
                  ) +
                  "\n            "
              )
            ]),
            _vm._v(" "),
            _c("CompassButton", {
              staticClass: "mt-3",
              attrs: {
                label: _vm.$t.__("common.actions.continue"),
                type: "primary"
              },
              on: { click: _vm.next }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("template", { slot: "footer" }, [_vm._v("   ")])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }